import { Injectable } from '@angular/core';
import PaginationResult from 'src/app/core/domain/pagination-result';
import { PatientGroupCommands } from 'src/app/data/dietitian/domain/patient_group/patient_group_commands';
import { Patient } from 'src/app/data/patient/domain/patient';
import { PatientCommands } from 'src/app/data/patient/domain/patient_commands';

import { SortListType } from '../../../questions/questions.service';

@Injectable()
export class PatientGroupPatientEditFacade {
  constructor(
    private patientCommands: PatientCommands,
    private patientGroupCommands: PatientGroupCommands,
  ) {
    // do nothing
  }

  searchPatients(
    dietitianId: string,
    query: string,
  ): Promise<PaginationResult<Patient>> {
    return this.patientCommands.searchDietitianPatients(
      dietitianId,
      query,
      SortListType.All,
      null,
      1000,
      0,
      'updatedAt',
      false,
    );
  }

  updatePatientGroupPatients(
    patientGroupId: string,
    patientIds: string[],
    updateTrackers: boolean,
  ): Promise<void> {
    return this.patientGroupCommands.updatePatientGroupPatients(
      patientGroupId,
      patientIds,
      updateTrackers,
    );
  }

  getPatientGroupPatients(
    dietitianId: string,
    patientGroupId: string,
  ): Promise<Patient[]> {
    return this.patientGroupCommands.getPatientGroupPatients(
      dietitianId,
      patientGroupId,
      false,
    );
  }
}
